import { FileText } from "lucide-react";
import { useRef, useState } from "react";
import { Document, Page } from "react-pdf/dist/esm/entry.webpack";

interface DocumentItemProps {
  rotation?: number;
  file: {
    id: string;
    file_path: string;
    filename: string;
    preview: string;
    isImage: boolean;
  };
}

export const DocumentItem = ({ file, rotation }: DocumentItemProps) => {
  const [isZoomed, setIsZoomed] = useState(false);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [numPages, setNumPages] = useState<number>(0);

  const imageRef = useRef<HTMLImageElement>(null);

  const handleMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
    if (!imageRef.current) return;

    const rect = imageRef.current.getBoundingClientRect();

    const centerX = rect.left + rect.width / 2;
    const centerY = rect.top + rect.height / 2;

    const dx = e.clientX - centerX;
    const dy = e.clientY - centerY;

    const angle = -(rotation || 0) * (Math.PI / 180);

    const rotatedX = dx * Math.cos(angle) - dy * Math.sin(angle);
    const rotatedY = dx * Math.sin(angle) + dy * Math.cos(angle);

    const x = ((rotatedX + rect.width / 2) / rect.width) * 100;
    const y = ((rotatedY + rect.height / 2) / rect.height) * 100;

    setMousePosition({ x, y });
  };

  const handleMouseEnter = () => {
    setIsZoomed(true);
  };

  const handleMouseLeave = () => {
    setIsZoomed(false);
  };

  const onDocumentLoadSuccess = ({
    numPages: totalPages,
  }: {
    numPages: number;
  }) => {
    setNumPages(totalPages);
  };

  return (
    <div className="document-item-style">
      <div
        className="file-preview"
        onMouseMove={handleMouseMove}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        style={{
          transform: `rotate(${rotation}deg)`,
          transition: "transform 0.2s ease-out",
        }}
      >
        {file.id ? (
          <>
            {!file.isImage ? (
              <div
                style={{ width: "100%", maxWidth: "1000px", margin: "0 auto" }}
              >
                <div
                  style={{
                    maxHeight: "70vh",
                    overflowY: "auto",
                    padding: "20px",
                    background: "white",
                    borderRadius: "8px",
                    border: "1px solid #ddd",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "20px",
                    }}
                  >
                    <Document
                      file={file.preview}
                      onLoadSuccess={onDocumentLoadSuccess}
                      className="pdf"
                    >
                      {Array.from(new Array(numPages), (el, pageIndex) => (
                        <div
                          key={`page_${pageIndex + 1}`}
                          style={{
                            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                            borderRadius: "4px",
                          }}
                        >
                          <Page pageNumber={pageIndex + 1} width={600} />
                        </div>
                      ))}
                    </Document>
                  </div>
                </div>
              </div>
            ) : (
              <>
                <img
                  src={file.preview}
                  ref={imageRef}
                  alt=""
                  style={{
                    transform: isZoomed ? "scale(2)" : "scale(1)",
                    transformOrigin: `${mousePosition.x}% ${mousePosition.y}%`,
                    transition: "transform 0.2s ease-out",
                    width: "100%",
                  }}
                />
              </>
            )}
          </>
        ) : (
          <>
            <FileText size={25} />
            <p>Área de Visualização</p>
          </>
        )}
      </div>
    </div>
  );
};
